<template>
  <div class="pcRight">
    <div class="operation">
      <div class="title">{{ currentInfo.componentDescribe }}</div>
      <div class="content">
        <component :is="currentInfo.component" />
      </div>
    </div>
    <!-- 新增窗口 -->
    <add-dialog @addPageItemList="addPageItemList" />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import addDialog from "./addDialog.vue";
// header
import header1 from "../template/header/header1/setting.vue";
// banner1
import banner1 from "../template/banner/banner1/setting.vue";

import banner2 from "../template/banner/banner2/setting.vue";
// goods
import goods1 from "../template/goods/goods1/setting.vue";
import goods2 from "../template/goods/goods2/setting.vue";
//propaganda
import propaganda1 from "../template/propaganda/propaganda1/setting.vue";
import propaganda2 from "../template/propaganda/propaganda2/setting.vue";
//module
import module1 from "../template/module/module1/setting.vue";
import module2 from "../template/module/module2/setting.vue";
import module3 from "../template/module/module3/setting.vue";
//footer
import footer1 from "../template/footer/footer1/setting.vue";
//other
import other1 from "../template/other/other1/setting.vue";
import other2 from "../template/other/other2/setting.vue";
export default {
  components: {
    addDialog,
    header1,
    banner1,
    propaganda1,
    goods1,
    goods2,
    other1,
    banner2,
    propaganda2,
    module1,
    module2,
    module3,
    other2,
    footer1,
  },
  computed: {
    ...mapGetters([
      "chooseComponentId",
      "templateList",
      "currentInfo",
      "currentIndex",
      "singleIndex",
      "addRemark",
    ]),
  },

  watch: {
    chooseComponentId() {
      this.getCurrentInfo();
    },
  },
  methods: {
    addPageItemList(list) {
      let arr = list.map((item) => {
        return {
          type: this.currentInfo.type,
          relationId: item.id,
          id: null,
          remark: this.addRemark,
          schoolPageInfo: { ...item },
        };
      });
      let obj = JSON.parse(JSON.stringify(this.currentInfo));
      if (this.singleIndex != undefined) {
        obj.wxSchoolPageItemList[this.singleIndex] = arr[0];
      } else {
        obj.wxSchoolPageItemList = obj.wxSchoolPageItemList.concat(arr);
      }
      this.$store.commit("design/SET_CURRENTINFO", obj);
    },
    getCurrentInfo() {
      if (this.chooseComponentId) {
        this.templateList.forEach((item, index) => {
          if (item.typeId == this.chooseComponentId) {
            if (!item.wxSchoolPageItemList) {
              item.wxSchoolPageItemList = [];
            }
            this.$store.commit("design/SET_CURRENTINFO", item);
            this.$store.commit("design/SET_CURRENTINDEX", index);
          }
        });
      } else {
        this.$store.commit("design/SET_CURRENTINFO", {});
        this.$store.commit("design/SET_CURRENTINDEX", undefined);
      }
      this.$store.commit("design/CHANGED_INDEX", true);
    },
  },
};
</script>
<style lang="less" scoped>
.pcRight {
  width: 400px;
  border-left: 1px solid #eee;
  height: 100%;
  overflow: auto;
  // background: #fff;
  .operation {
    width: 100%;
    height: 100%;
    background-color: #fff;
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(238, 238, 238, 1);
    font-family: "微软雅黑";
    font-weight: 400;
    font-style: normal;
  }
  .title {
    height: 40px;
    color: #000;
    font-size: 16px;
    line-height: 40px;
    padding-left: 10px;
    box-sizing: border-box;
    width: 100%;
    background: rgba(238, 236, 236, 100);
  }
  .content {
    padding: 10px;
    box-sizing: border-box;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/designPage/components/pcRight.vue